
"use client"
import { a11yScript, autoWebViewJs, isInAndroid } from '@droid/android';
import { AndroidPermissionStatus, usePermissionStatus } from '@app/model';
import { useTabActivity } from '@fanfanlo';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import { Box, Button, ClickAwayListener, Tooltip } from '@mui/material';
import { useEffect, useState } from 'react';
// import { useTranslation } from 'react-i18next';s
import { useTranslation } from '@fanfanlo';
import { useRouter } from 'next/router';


interface IA11yServiceLiveInfo {
  hasPermission?: boolean
  hasService?: boolean
  isAlive?: boolean
  pingTime?: number
  crashed?: boolean
}
export function AccessibilityInfo() {
  const { t } = useTranslation('homepage/components/permissions/accessibility/content');
  const [hasPermission, setHasPermission] = useState(a11yScript.hasPermission())
  const status = usePermissionStatus(hasPermission ? AndroidPermissionStatus.granted : AndroidPermissionStatus.shouldAskAgain);
  const [openTooltip, setOpenTooltip] = useState(false);
  const isActive = useTabActivity()  
  const router =useRouter();
  function onSettingClick(){
    // if(!isInAndroid())return;
    autoWebViewJs.onCallOpenA11yPermission()
  }
  useEffect(()=>{
    if(!isActive)return
    setHasPermission(a11yScript.hasPermission())
  }, [isActive])  
  useEffect(()=>{
    if(!isInAndroid()){
      console.log('check a11y permission in webview,but not in android')
      return;
    }
    let script = `var info =com.fanfanlo.droidlib.auto.components.webview.AutoWebViewJs.a11yModel.serviceLiveInfo;\n var s = com.fanfanlo.lib.utils.companion.gson2.toJson(info);\n s;`
    script = `var info =com.fanfanlo.droidlib.auto.components.webview.AutoWebViewJs.a11yModel.serviceLiveInfo;\n var s = com.fanfanlo.lib.utils.JsonUtil.gson2.toJson(info);\n s;`
    const info = autoWebViewJs.callScript<IA11yServiceLiveInfo>(script)
    const bl = a11yScript.checkPermission()
  }, []);

  function onDangerPageButtonClick(){
    router.push('/a11y-danger')
  }
  return (
    <Box>
      <Box>
        <span>{t('AccessibilityInfo.name')}</span>
        <span>:</span>
        <button onClick={onSettingClick}
         role='button' style={{marginLeft:"0.5rem", marginRight:"0.5rem"}} data-testid="AccessibilityInfo__settingButton__01JG2B0070" data-test-comment="无障碍设置按钮，点击后打开系统无障碍服务设置">{t('AccessibilityInfo.setting')}</button>
        <span>{status}</span>
        <span>{hasPermission ? 'ok' : 'no'}</span>
        <span style={{ paddingLeft: '1rem' }}></span>
        <ClickAwayListener onClickAway={() => setOpenTooltip(false)}>
          <Tooltip
            disableFocusListener
            disableHoverListener
            disableTouchListener
            title={t("AccessibilityInfo.dangerDesc")}
            slotProps={{
              popper: {
                disablePortal: true,
              },
            }}
            open={openTooltip}
            onOpen={() => setOpenTooltip(true)}
            onClose={() => setOpenTooltip(false)}>
            <span onMouseDown={() => setOpenTooltip(true)}>
              <span>{t('AccessibilityInfo.danger')}</span>
              <span></span>
              <span>
                <QuestionMarkIcon fontSize="small" sx={{ verticalAlign: 'sub' }} />
              </span>
              <span style={{color:"red"}}>
                <Button onClick={onDangerPageButtonClick} data-testid="AccessibilityInfo__dangerButton__01JG2B0071" data-test-comment="无障碍危险警告按钮，点击后导航到无障碍危险提示页面">警告</Button>
              </span>
            </span>
          </Tooltip>
        </ClickAwayListener>
      </Box>
    </Box>
  );
}
